"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SearchField = exports.CheckboxWithCenteredLabel = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _base = _interopRequireDefault(require("@emotion/styled/base"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _uuid = require("uuid");

var _Dropdown = _interopRequireDefault(require("../Dropdown/Dropdown"));

var _Search = _interopRequireDefault(require("../Search/Search"));

var _Checkbox = _interopRequireDefault(require("../Checkbox/Checkbox"));

var _hooks = require("../../hooks");

var _Dropdown2 = require("../Dropdown/Dropdown.styles");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var CheckboxWithCenteredLabel = ( /*#__PURE__*/0, _base["default"])(_Checkbox["default"], {
  target: "e13xapeb1",
  label: "CheckboxWithCenteredLabel"
})(process.env.NODE_ENV === "production" ? {
  name: "4o4isz",
  styles: "flex-grow:1;overflow:hidden;label{align-items:center;}"
} : {
  name: "4o4isz",
  styles: "flex-grow:1;overflow:hidden;label{align-items:center;}",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
exports.CheckboxWithCenteredLabel = CheckboxWithCenteredLabel;
var SearchField = ( /*#__PURE__*/0, _base["default"])(_Search["default"], {
  target: "e13xapeb0",
  label: "SearchField"
})(process.env.NODE_ENV === "production" ? {
  name: "1d3w5wq",
  styles: "width:100%"
} : {
  name: "1d3w5wq",
  styles: "width:100%",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
exports.SearchField = SearchField;
var selectAllId = (0, _uuid.v4)(); // otherProps are for Dropdown component

var DropdownWithCheckbox = function DropdownWithCheckbox(_ref) {
  var list = _ref.list,
      searchFor = _ref.searchFor,
      onChange = _ref.onChange,
      children = _ref.children,
      otherProps = (0, _objectWithoutProperties2["default"])(_ref, ["list", "searchFor", "onChange", "children"]);

  var _useState = (0, _react.useState)(list),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      filteredList = _useState2[0],
      setFilteredList = _useState2[1];

  var _useState3 = (0, _react.useState)(''),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      searchValue = _useState4[0],
      setSearchValue = _useState4[1];

  var _useCheckAll = (0, _hooks.useCheckAll)(filteredList, onChange),
      indeterminate = _useCheckAll.indeterminate,
      checkAll = _useCheckAll.checkAll,
      checkedList = _useCheckAll.checkedList,
      handleCheckAllChange = _useCheckAll.handleCheckAllChange,
      handleChange = _useCheckAll.handleChange;

  var handleChangeSeach = (0, _react.useCallback)(function (_ref2) {
    var target = _ref2.target;
    setSearchValue(target.value);
    var lowercasedValue = target.value.toLowerCase();
    setFilteredList(list.filter(function (_ref3) {
      var label = _ref3.label;
      return label.toLowerCase().indexOf(lowercasedValue) > -1;
    }));
  }, [list]);
  var searchField = (0, _jsxRuntime.jsx)("div", {
    css: _Dropdown2.styles.item,
    children: (0, _jsxRuntime.jsx)(SearchField, {
      name: "search",
      placeholder: "Search for ".concat(searchFor, "..."),
      onChange: handleChangeSeach,
      value: searchValue
    })
  });

  var menuWithCheckboxes = function menuWithCheckboxes(listData) {
    return (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [searchField, (0, _jsxRuntime.jsxs)(_Dropdown["default"].Menu, {
        children: [filteredList.length > 0 ? (0, _jsxRuntime.jsx)(_Dropdown["default"].Menu.Item, {
          highlight: true,
          itemKey: "all",
          children: (0, _jsxRuntime.jsx)(_Checkbox["default"], {
            id: selectAllId,
            indeterminate: indeterminate,
            onChange: handleCheckAllChange,
            checked: checkAll,
            children: checkAll ? 'Unselect all' : 'Select all'
          })
        }, "all") : null, listData.map(function (_ref4) {
          var value = _ref4.value,
              label = _ref4.label;
          return (0, _jsxRuntime.jsx)(_Dropdown["default"].Menu.Item, {
            itemKey: value,
            children: (0, _jsxRuntime.jsx)(CheckboxWithCenteredLabel, {
              id: value,
              onChange: handleChange,
              checked: checkedList.some(function (item) {
                return item.value === value;
              }),
              value: value,
              truncate: true,
              children: label
            })
          }, value);
        })]
      })]
    });
  };

  return (0, _jsxRuntime.jsx)(_Dropdown["default"], _objectSpread(_objectSpread({
    overlay: menuWithCheckboxes(filteredList),
    hasMinWidth: true,
    autoHeight: true
  }, otherProps), {}, {
    children: children
  }));
};

DropdownWithCheckbox.propTypes = {
  /**
   * All selections
   */
  list: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    value: _propTypes.string,
    label: _propTypes.string
  })).isRequired,

  /**
   * Part of search placeholder
   */
  searchFor: _propTypes.string.isRequired,

  /**
   * The callback function that is triggered when the state changes</br>
   * return checked list
   */
  onChange: _propTypes.func,
  children: _propTypes.node
};
DropdownWithCheckbox.defaultProps = {
  onChange: function onChange() {},
  children: undefined
};
var _default = DropdownWithCheckbox;
exports["default"] = _default;
//# sourceMappingURL=DropdownWithCheckbox.js.map